import {SerializeClass} from "models/SerializeClass";

export enum DateRangePresets {
	PREVIOUS_FULL_MONTH = 'previousFullMonth',
	CURRENT_MONTH = 'currentMonth',
	CURRENT_FULL_MONTH = 'currentFullMonth',
	NEXT_FULL_MONTH = 'nextFullMonth',
}

export class DateRange extends SerializeClass {


	private _from: string = "";
	private _to: string = "";
	private _preset: number | DateRangePresets | string = "";


	constructor(from: string = "", to: string = "", preset: number | DateRangePresets | string = null) {
		super();
		this._from = from;
		this._to = to;
		this._preset = preset;
	}

	get from(): string {
		return this._from;
	}

	set from(value: string) {
		this._from = value;
	}

	get to(): string {
		return this._to;
	}

	set to(value: string) {
		this._to = value;
	}


	get preset(): number | DateRangePresets | string {
		return this._preset;
	}

	set preset(value: number | DateRangePresets | string) {
		this._preset = value;
	}
}